import { useState } from "react";
import { UserPlus, FolderPlus, Receipt, Users } from "lucide-react";
import CreazioneRapidaContrattoDialog from "./CreazioneRapidaContrattoDialog";
import UploadFascicoloDocumentDialog from "./UploadFascicoloDocumentDialog";
import InviaOspiteReteDialog from "./InviaOspiteReteDialog";
import PrimaNotaRapidaDialog from "./PrimaNotaRapidaDialog";
import Stampa118Dialog from "./Stampa118Dialog";

const ACTIONS = [
  {
    id: "contratto",
    line1: "Creazione rapida",
    line2: "ospite con firma contratto",
    icon: UserPlus,
    bg: "bg-[#22c55e]",
  },
  {
    id: "documento",
    line1: "Aggiungi documento",
    line2: "fascicolo ospite",
    icon: FolderPlus,
    bg: "bg-[#a855f7]",
  },
  {
    id: "rete",
    line1: "Invia ospite",
    line2: "in Ospiti in Rete",
    icon: Users,
    bg: "bg-[#3b82f6]",
  },
  {
    id: "prima-nota",
    line1: "Aggiungi spesa",
    line2: "in Prima Nota",
    icon: Receipt,
    bg: "bg-[#f97316]",
  },
  {
    id: "118",
    line1: "Stampa scheda",
    line2: "ospite (118)",
    icon: null,
    bg: "bg-[#ef4444]",
  },
];

export default function PanoramicaQuickActionsBar() {
  const [activeDialog, setActiveDialog] = useState(null);

  return (
    <>
      <section
        className="bg-white rounded-2xl border border-slate-200/80 shadow-[0_2px_12px_rgba(15,23,42,0.06)] px-4 sm:px-5 py-3 sm:py-4"
        aria-label="Azioni rapide"
      >
        <div className="flex gap-3 sm:gap-4 overflow-x-auto pb-0.5 -mx-1 px-1 scrollbar-thin lg:grid lg:grid-cols-5 lg:overflow-visible lg:gap-2 xl:gap-4">
          {ACTIONS.map((action, idx) => (
            <button
              key={action.id}
              type="button"
              onClick={() => setActiveDialog(action.id)}
              className="group flex items-center gap-2.5 sm:gap-3 min-w-[148px] sm:min-w-[168px] lg:min-w-0 flex-shrink-0 lg:flex-shrink text-left rounded-xl px-1 py-1 -mx-1 transition-colors hover:bg-slate-50/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500/40"
              data-testid={`panoramica-azione-rapida-${idx}`}
              title={`${action.line1} ${action.line2}`}
            >
              <div
                className={`w-11 h-11 sm:w-12 sm:h-12 rounded-full ${action.bg} flex items-center justify-center shrink-0 transition-transform group-hover:scale-[1.04]`}
              >
                {action.id === "118" ? (
                  <span className="text-white text-[13px] sm:text-sm font-bold tracking-tight">118</span>
                ) : (
                  <action.icon className="w-5 h-5 sm:w-[22px] sm:h-[22px] text-white" strokeWidth={2.25} />
                )}
              </div>

              <div className="min-w-0 pr-1">
                <p className="text-[12px] sm:text-[13px] font-bold text-slate-900 leading-[1.25] whitespace-normal">
                  {action.line1}
                </p>
                <p className="text-[12px] sm:text-[13px] font-semibold text-slate-700 leading-[1.25] whitespace-normal mt-0.5">
                  {action.line2}
                </p>
              </div>
            </button>
          ))}
        </div>
      </section>

      <CreazioneRapidaContrattoDialog
        open={activeDialog === "contratto"}
        onOpenChange={(v) => !v && setActiveDialog(null)}
      />
      <UploadFascicoloDocumentDialog
        open={activeDialog === "documento"}
        onOpenChange={(v) => !v && setActiveDialog(null)}
      />
      <InviaOspiteReteDialog
        open={activeDialog === "rete"}
        onOpenChange={(v) => !v && setActiveDialog(null)}
      />
      <PrimaNotaRapidaDialog
        open={activeDialog === "prima-nota"}
        onOpenChange={(v) => !v && setActiveDialog(null)}
      />
      <Stampa118Dialog
        open={activeDialog === "118"}
        onOpenChange={(v) => !v && setActiveDialog(null)}
      />
    </>
  );
}
